
import { Component, Vue } from 'vue-property-decorator';

import {
  getPartsList,
  setPartsSetting,
  addParts,
  editParts,
  deleteParts,
  addModel,
  editModel,
  deleteModel,
  exportParts
} from '@/api/parts';
import { UserModule } from '@/store/modules/user';
import { parse } from 'path';
import { IPagination } from '@/types';
import { makeKey } from '@/utils/qiniu';
import { getQiniuToken } from '../../api/third';
import { Qiniu } from '@/types/qiniu';
import dialogImgLarge from '@/components/ImgLarge/index.vue';
import dialogSetImport from '../staff/components/setImport.vue';
import {
  checkPermissionCompany
} from '@/utils/permission';
import { Type } from '@/types/permissionType';
import { getUserInfo } from '@/api/users';
import { toFixed2 } from '@/utils';

// 1已同步 2未同步
const statusOptions = [
  {
    value: '2',
    label: '未同步'
  },
  {
    value: '1',
    label: '已同步'
  }
];
const sourceType = [
  {
    value: '3',
    label: '工程师'
  },
  {
    value: '1',
    label: '公司'
  }
];
@Component({
  name: 'PartsMine',
  components: {
    dialogImgLarge,
    dialogSetImport
  },
  filters: {
    getSource(val: any) {
      let t = '';
      switch (parseInt(val)){
        case 1:
          t='公司';
          break;
        case 3:
          t='工程师';
          break;
        default:
          t='';
          break;
      }
      return t;
    }
  }
})
export default class extends Vue {
  // 7牛
  private qiniuDomain: string = 'https://up-z1.qiniup.com';
  private qiuniuform = {};
  private qiniu: any;

  private pagination: any = {
    currentPage: 1,
    pageSize: 10,
    total: 0
  };
  private formSearch = {
    part: '',
    model: '',
    status: ''
  };
  private statusOptions = statusOptions;
  private sourceType=sourceType;
  private isShowStatus=false;

  private sourceTypeDisabled=true;

  private showPartsAmount =
    parseInt((UserModule.getCompany as any).is_parts_price_show) === 1;
  private isPartsChange =
    parseInt((UserModule.getCompany as any).is_modify_price) === 1;
  private isPartsApply =
    parseInt((UserModule.getCompany as any).is_parts_apply) === 1;
  private listLoading = false;
  private tableData = [];
  private multipleSelectionData = [];
  private dialogAddPartVisible = false;
  private formAddPart = {
    id: '',
    type: 1,
    name: '',
    price: '',
    serial: '',
    specification: '',
    remark: '',
    imageUrl: '',
    is_apply:false,
    sort: 100
  };
  private dialogAddModelVisible = false;
  private formAddModel = {
    id: '',
    type: 1,
    parts_name: '',
    parts_id: '',
    price: '',
    serial: '',
    specification: '',
    imageUrl: '',
    name: '',
    remark: '',
    imgKey: '',
    sort: 100,
    baseCostCompany: '',
    baseCostPerson: '',
    sourceType: '',
    is_apply:false,
  };
  created() {
    this.isShowStatus = checkPermissionCompany(UserModule.getCompanyId, Type.Stock);
    const params = {
      type: Qiniu.UPLOAD_TYPE_PARTS
    };
    getQiniuToken(params).then((res) => {
      if (res && res.data) {
        this.qiniu = res.data;
      }
    });
    this.getPartsList();
  }
  handleCurrentChange(size: number) {
    this.pagination.currentPage = size;
    this.getPartsList();
  }

  handlePageSizeChange(size: number) {
    this.pagination.currentPage = 1;
    this.pagination.pageSize = size;
    this.getPartsList();
  }

  // 搜索
  private handleSearch() {
    this.pagination.currentPage = 1;
    this.getPartsList();
  }

  // 清空
  private handleSearchClear() {
    this.pagination.currentPage = 1
    this.formSearch = {
      part: '',
      model: '',
      status: ''
    };
    this.getPartsList();
  }

  // 获取备件列表
  private getPartsList() {
    this.listLoading = true;
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_name: this.formSearch.part,
      modal_name: this.formSearch.model,
      is_sync: this.formSearch.status,
      page: this.pagination.currentPage,
      size: this.pagination.pageSize,
      pid:0,
    };
    getPartsList(params)
      .then((res: any) => {
        const data = res.data;
        if (data !== null) {
          this.pagination.total = parseInt(data.count);
          this.tableData = data.list;
        } else {
          this.pagination.total = 0;
          this.tableData = [];
        }
        this.listLoading = false;
      })
      .catch((err: any) => {
        this.pagination.total = 0;
        this.tableData = [];
        this.listLoading = false;
        let msg = err.msg;
      });
  }

  // 设置 不显示备件费用金额详情
  private settingChange1(val: any) {
    const params = {
      is_parts_price_show: val ? 1 : 0
    };
    this.partsSetting(params);
  }
  // 设置 备件可修改费用
  private settingChange2(val: any) {
    const params = {
      is_modify_price: val ? 1 : 0
    };
    this.partsSetting(params);
  }

    // 设置 备件可修改费用
  private settingApply(val: any) {
    const params = {
      is_parts_apply: val ? 1 : 0
    };
    this.partsSetting(params);
  }

  // 调用备件设置接口
  private partsSetting(val: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      ...val
    };
    setPartsSetting(params)
      .then(async(res: any) => {
        this.showSuccessMsg(res.msg);
        let parameters: any = {};
        parameters.user_id = UserModule.getUserId;
        parameters.company_id = UserModule.getCompanyId;
        await getUserInfo(parameters).then(async(res) => {
          await UserModule.setLogin(res.data);
        });
      })
      .catch((err: any) => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  private closeAddParts() {
    this.dialogAddPartVisible = false;
    this.formAddPart = {
      id: '',
      type: 1,
      name: '',
      price: '',
      serial: '',
      specification: '',
      remark: '',
      imageUrl: '',
      sort: 100,
      is_apply:false,
    };
  }

  // 添加备件按钮触发
  private addPartHandle() {
    this.dialogAddPartVisible = true;
    this.formAddPart.type = 1;
  }
  // 添加备件保存按钮触发
  private addPartsSave() {
    if (this.formAddPart.type === 1) {
      this.addParts();
    } else {
      this.editParts();
    }
  }

  // 添加备件
  private addParts() {
    if (!this.formAddPart.name) {
      this.showErrorMsg('请输入名称');
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      name: this.formAddPart.name,
      is_apply: this.formAddPart.is_apply ? 1 : 0,
      sort: this.formAddPart.sort
    };
    addParts(params)
      .then((res: any) => {
        this.closeAddParts();
        this.showSuccessMsg(res.msg);
        this.getPartsList();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 编辑备件
  private editPartsHandle(val: any) {
    this.dialogAddPartVisible = true;
    this.formAddPart.type = 2;
    this.formAddPart.name = val.name;
    this.formAddPart.id = val.id;
    this.formAddPart.is_apply = parseInt(val.is_apply)==1 ? true : false,
    this.formAddPart.sort = val.sort;
  }

  // 编辑备件
  private editParts() {
    if (!this.formAddPart.name) {
      this.showErrorMsg('请输入名称');
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_id: this.formAddPart.id,
      name: this.formAddPart.name,
      is_apply: this.formAddPart.is_apply ? 1 : 0,
      sort: this.formAddPart.sort
    };
    editParts(params)
      .then((res: any) => {
        this.closeAddParts();
        this.showSuccessMsg(res.msg);
        this.getPartsList();
      })
      .catch((err: any) => {
        this.showErrorMsg(err.msg);
      });
  }

  // 删除备件
  private deletePartsHandle(val: any) {
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        _this.deleteParts(val.id);
      })
      .catch(() => {});
  }

  private deleteParts(val: any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_id: val
    };
    deleteParts(params)
      .then((res: any) => {
        this.showSuccessMsg('删除成功');
        this.getPartsList();
      })
      .catch(err => {
        this.showErrorMsg(err.msg);
      });
  }

  // 添加型号按钮触发
  private addModelHandle(val: any) {
    this.formAddModel.parts_name = val.name;
    this.formAddModel.parts_id = val.id;
    this.formAddModel.type = 1;
    this.formAddModel.sourceType = '1';
    this.dialogAddModelVisible = true;
  }

  // 关闭添加型号 dialog清楚数据
  private closeAddModel() {
    this.dialogAddModelVisible = false;
    this.formAddModel = {
      id: '',
      type: 1,
      parts_id: '',
      parts_name: '',
      price: '',
      serial: '',
      specification: '',
      imageUrl: '',
      name: '',
      remark: '',
      imgKey: '',
      sort: 100,
      baseCostCompany: '',
      baseCostPerson: '',
      sourceType: '1',
      is_apply:false,
    };
  }
  private proving1(type:number) {
    if (type === 1) {
      this.formAddModel.baseCostCompany = toFixed2(this.formAddModel.baseCostCompany);
    } else {
      this.formAddModel.baseCostPerson = toFixed2(this.formAddModel.baseCostPerson);
    }
  }
  // 添加/编辑型号保存触发
  private addModelSave() {
    if (this.formAddModel.type === 1) {
      this.addModel();
    } else {
      this.editModel();
    }
  }

  // 添加型号 保存数据
  private addModel() {
    if (!this.formAddModel.name) {
      this.showErrorMsg('请输入备件型号');
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_id: this.formAddModel.parts_id,
      name: this.formAddModel.name,
      remark: this.formAddModel.remark,
      serial_number: this.formAddModel.serial,
      specification: this.formAddModel.specification,
      image_save_path: this.formAddModel.imgKey,
      unit_price: this.formAddModel.price,
      sort: this.formAddModel.sort,
      company_price: this.formAddModel.baseCostCompany,
      person_price: this.formAddModel.baseCostPerson,
      source_type: this.formAddModel.sourceType,
      is_apply: this.formAddModel.is_apply ? 1 : 0,
    };
    addModel(params)
      .then((res: any) => {
        this.closeAddModel();
        this.showSuccessMsg(res.msg);
        this.getPartsList();
      })
      .catch(err => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  // 编辑型号
  private editModelHandle(val: any, valp: any) {
    this.formAddModel = {
      type: 2,
      id: val.id,
      parts_name: valp.name,
      parts_id: valp.id,
      price: val.unit_price,
      serial: val.serial_number,
      specification: val.specification,
      imageUrl: val.image_save_path,
      name: val.name,
      remark: val.remark,
      imgKey: val.image_short_path,
      sort: val.sort,
      baseCostCompany: val.company_price,
      baseCostPerson: val.person_price,
      sourceType: val.source_type,
      is_apply: parseInt(val.is_apply)==1 ? true : false,
    };
    this.sourceTypeDisabled = parseInt(val.source_type) === 1
    this.dialogAddModelVisible = true;
  }

  private editModel() {
    if (!this.formAddModel.name) {
      this.showErrorMsg('请输入备件型号');
      return;
    }
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      parts_id: this.formAddModel.parts_id,
      model_id: this.formAddModel.id,
      name: this.formAddModel.name,
      remark: this.formAddModel.remark,
      serial_number: this.formAddModel.serial,
      specification: this.formAddModel.specification,
      image_save_path: this.formAddModel.imgKey,
      unit_price: this.formAddModel.price,
      sort: this.formAddModel.sort,
      company_price: this.formAddModel.baseCostCompany,
      person_price: this.formAddModel.baseCostPerson,
      source_type: this.formAddModel.sourceType,
      is_apply: this.formAddModel.is_apply ? 1 :0 ,
    };
    editModel(params)
      .then((res: any) => {
        this.closeAddModel();
        this.showSuccessMsg(res.msg);
        this.getPartsList();
      })
      .catch(err => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  // 删除备件型号
  private deleteModelHandle(val: any, valp: any) {
    let _this = this;
    this.$confirm('确认删除吗?', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    })
      .then(() => {
        _this.deleteModel(val.id);
      })
      .catch(() => {});
  }

  private deleteModel(val:any) {
    const params = {
      user_id: UserModule.getUserId,
      company_id: UserModule.getCompanyId,
      model_id: val
    };
    deleteModel(params)
      .then((res: any) => {
        this.dialogAddModelVisible = false;
        this.showSuccessMsg(res.msg);
        this.getPartsList();
      })
      .catch((err: any) => {
        let msg = err.msg;
        this.showErrorMsg(msg);
      });
  }

  // 批量删除
  private deleteGroupHandle() {
    if (this.multipleSelectionData.length > 0) {
      let _this = this;
      this.$confirm('确认删除吗?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          var tempId = '';
          for (var i = 0; i < this.multipleSelectionData.length; i++) {
            tempId += (this.multipleSelectionData[i] as any).id + ',';
          }
          if (tempId.endsWith(',')) {
            tempId = tempId.slice(0, tempId.length - 1);
          }
          _this.deleteParts(tempId);
        })
        .catch(() => {});
    } else {
      this.$notify({
        title: '提示',
        message: '请选择需要删除的备件',
        type: 'warning'
      });
    }
  }
  private selectable(row:any, index:any) {
    let del = true;
    if (parseInt(row.is_charge_off) === 1) {
      del = false;
    }
    return del;
  }
  private handleSelectionChange(val: any) {
    this.multipleSelectionData = val;
  }

  private handleAvatarSuccess(res: any, file: any) {
    this.formAddModel.imageUrl = this.qiniu.default_url + res.key;
    this.formAddModel.imgKey = res.key;
  }
  private beforeAvatarUpload(file: any) {
    const isJPG = file.type === 'image/jpeg' || file.type === 'image/png';
    const isLt2M = file.size / 1024 / 1024 < 5;
    if (!isJPG) {
      return this.$message.error('上传文件只能是  JPG或PNG 格式!');
    }
    if (!isLt2M) {
      return this.$message.error('上传图片大小不能超过 5MB!');
    }
    return new Promise((resolve, reject) => {
      resolve(true);
    }).then((res) => {
      let k = makeKey(this.qiniu.prekey);
      this.qiuniuform = {
        key: k,
        token: this.qiniu.uptoken,
        domain: this.qiniu.domain
      };
    });
  }

  private deleteImgHandle() {
    this.formAddModel.imageUrl = '';
    this.formAddModel.imgKey = '';
  }

  // 导出Excel
  handleExport() {
    let params = {
      user_id: UserModule.getUserId,
      user_name: UserModule.getUserName,
      company_id: UserModule.getCompanyId,
      company_name: UserModule.getCompanyName
    };
    exportParts(params).then(res => {
      this.$confirm('是否跳转下载页面？', '跳转', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        let routeData = this.$router.resolve({
          path: '/ExportTask',
          query: {}
        });
        window.open(routeData.href);
      }).catch(() => {

      });
    }).catch(err => {
      this.showErrorMsg(err.msg);
    });
  }

  private imgLargeHandle(val: [], index: number) {
    let enlargedData = {
      isShow: true,
      imgList: [val],
      initNum: index
    };
    this.$store.dispatch('toggleEnlarged', enlargedData);
  }
  // 导入
  private setImportVisible = false
  private setImportTitle='导入备件'
  private importHandle() {
    this.setImportVisible = true;
  }
  closeImport(value: boolean) {
    this.getPartsList();
    this.setImportVisible = value;
  }
  private showErrorMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: 100,
      type: 'error'
    });
  }
  private showSuccessMsg(msg: string) {
    this.$notify({
      title: '提示',
      message: msg,
      offset: window.innerHeight * 0.4,
      customClass: 'notification-center',
      type: 'success'
    });
  }
}
